import { accountBadgeDistributionStatuses, editDistributionStatusBulkActionName, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { getFilterForBulkAction } from '../../../../ui/util/getFilterForBulkAction';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Typography } from '@mui/material';
import React from 'react';
export function useAccountBadgeEditDistributionBulkAction({ badgeId, accountBadgeSelectedIds, onClose, appliedStorageFilters, filteredRowCount, }) {
    const { t } = useBadgingTranslation();
    const bulkActionFilters = getFilterForBulkAction(accountBadgeSelectedIds, appliedStorageFilters);
    const handleChangeDistributionStatus = () => {
        showFormDialog({
            title: t('badges.badgeDetails.accountBadgeTable.bulkActions.changeDistribution.title', {
                count: accountBadgeSelectedIds.length > 0 ? accountBadgeSelectedIds.length : filteredRowCount,
            }),
            config: {
                type: 'form',
                children: [
                    {
                        type: 'form.content',
                        key: 'content',
                        render: () => (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, t('badges.badgeDetails.accountBadgeTable.bulkActions.changeDistribution.description'))),
                    },
                    {
                        type: 'form.advancedRadio',
                        key: 'distributionStatus',
                        validate: { required: true },
                        values: accountBadgeDistributionStatuses.map((accountBadgeDistributionStatus) => ({
                            value: accountBadgeDistributionStatus,
                            label: t(`badges.badgeDetails.distributionStatuses.${accountBadgeDistributionStatus}`),
                            description: t(`badges.badgeDetails.distributionStatusDescriptions.${accountBadgeDistributionStatus}`),
                        })),
                    },
                ],
            },
            submitLabel: t('common.save'),
            onSubmit: ({ distributionStatus }) => {
                launchBulkAction({
                    title: t('badges.badgeDetails.accountBadgeTable.bulkActions.changeDistribution.progressMessage'),
                    type: editDistributionStatusBulkActionName,
                    params: { badgeId, filter: bulkActionFilters, distributionStatus },
                    runSync: false,
                    onClose: ({ status, result }) => {
                        if (status === 'finished') {
                            showAlertSnackbar({
                                horizontalPosition: 'center',
                                type: (result === null || result === void 0 ? void 0 : result.updatedCount) ? 'success' : 'error',
                                verticalPosition: 'bottom',
                                autoHideDuration: 2000,
                                message: (result === null || result === void 0 ? void 0 : result.updatedCount)
                                    ? t('badges.badgeDetails.accountBadgeTable.bulkActions.changeDistribution.successMessage', {
                                        count: result.updatedCount,
                                    })
                                    : t('badges.badgeDetails.accountBadgeTable.bulkActions.invalidMessage', {
                                        action: 'Change Distribution',
                                    }),
                            });
                            onClose();
                        }
                        else if (status === 'failed') {
                            showErrorDialog({
                                title: t('badges.badgeDetails.accountBadgeTable.bulkActions.changeDistribution.failedMessage'),
                            });
                        }
                    },
                });
            },
            sx: {
                pt: 0,
            },
        });
    };
    return {
        handleChangeDistributionStatus,
    };
}
